import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import {
  anyNumberConvertInWord,
  DefaultTablePagination, displayDate, InputBox
} from '../../components/_utils/appUtils'
import { ColumnWidth } from '../WebComponent/columnWidth'
import { Col, DatePicker, Popconfirm, Row, Tooltip } from 'antd'
import { approveAdvanceCommissionFxn, getAllAdvanceCommissionsFxn } from './actions'
import AgentTypeheadComponent from '../../components/_utils/AgentTypeheadComponent'
import moment from 'moment'

let { RangePicker } = DatePicker

class AdvanceCommissionList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      visibleDepositDrawer: false,
      agentId: '',
      toDate: '',
      fromDate: ''
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    //use effect
  }

  events = {
    reload: () => {
      this.tableRef.current.reload()
    },
    approveDeposit: async (advanceCommissionId) => {
      let { dispatch } = this.props
      let resp = await dispatch(approveAdvanceCommissionFxn({ advanceCommissionId }))
      if (resp && resp.success) {
        if (this.tableRef && this.tableRef.current) {
          this.tableRef.current.reload()
        }
      }
    }
  }


  apiRequest = (params) => {
    let { dispatch } = this.props
    return new Promise(async (resolve) => {
      if (this.state.agentId) {
        params.agentId = this.state.agentId
      }
      if (this.state.fromDate && this.state.toDate) {
        params.casIssueDate = {
          $gte: moment(this.state.fromDate).startOf('day').toDate(),
          $lte: moment(this.state.toDate).endOf('day').toDate()
        }
      }
      params.sortField = '_id'
      params.sortOrder = 'descend'
      let data = await dispatch(getAllAdvanceCommissionsFxn({
        ...params
      }))
      resolve(data)
    })
  }

  searchFxn = async () => {
    this.events.reload()
  }

  clearFxn = async () => {
    this.setState({
      agentId: '',
      toDate: '',
      fromDate: ''
    })
    setTimeout(() => {
      this.events.reload()
    }, 200)
  }

  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Agent Name',
        key: 'agentName',
        dataIndex: 'agentName',
        width: 200,
        render: (item, record) => {
          return (
            <ColumnWidth width={200}>
              {item} ({record.agentCompanyName})
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Student (Application Id)',
        key: 'studentName',
        sorter: true,
        dataIndex: 'studentName',
        searchTextName: 'studentName',
        width: 150,
        render: (item, record) => {
          return (
            <ColumnWidth width={150}>
              {item} <br /> (App Id - {record.appId})
            </ColumnWidth>
          )
        }
      },

      {
        title: 'University (Course)',
        key: 'universityName',
        sorter: true,
        dataIndex: 'universityName',
        searchTextName: 'universityName',
        width: 200,
        render: (item, record) => {
          return (
            <ColumnWidth width={200}>
              {item}<br /> ({record.courseName})
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Country',
        key: 'countryName',
        dataIndex: 'countryName',
        width: 70,
        render: (item) => {
          return (
            <ColumnWidth width={70}>
              {item}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Amount',
        key: 'amount',
        dataIndex: 'amount',
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              <Tooltip title={anyNumberConvertInWord(item)}>
                {record.currency && record.currency} {item} {record.currencyName && record.currencyName}
              </Tooltip>
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        searchTextName: 'status',
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              {
                item == 'Pending' ?
                  <Tooltip title={'Approve Deposit'}>
                    <Popconfirm title={'Are your sure, you want to approve this record?'}
                                onConfirm={() => {
                                  this.events.approveDeposit(record._id)
                                }}>
                      <a className={'btn btn-default roundNew sm'}>
                        {item}
                      </a>
                    </Popconfirm>
                  </Tooltip> : item == 'Approved' ?
                  < a className={'btn btn-success-green roundNew sm'}>
                    {item}
                  </a> : ''
              }

            </ColumnWidth>
          )
        }
      },
      {
        title: 'Student IDs',
        dataIndex: 'AppIds',
        key: 'AppIds',
        width: 80,
        render: (item, record) => {
          const navToSearchPage = (appId) => {
            let url = `/searchApplication/view?applicationId=${appId}`
            window.open(url, '_blank')
          }
          return (
            <ColumnWidth width={80}>
              <a className={'btn btn-default roundNew xs'}
                 onClick={() => navToSearchPage(record.appId)}
                 key={record.appId}>{record.appId}</a>
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Cas Issue Date',
        key: 'casIssueDate',
        dataIndex: 'casIssueDate',
        width: 80,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              {displayDate(item)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Approved Date',
        key: 'approvedDate',
        dataIndex: 'approvedDate',
        width: 80,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              {displayDate(item)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Withdrawal Date',
        key: 'universityCommissionId',
        dataIndex: 'universityCommissionId',
        width: 80,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              {item && item.withdrawalDate ? displayDate(item.withdrawalDate) : '--'}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Approved By',
        key: 'approvedBy',
        dataIndex: 'approvedBy',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={200}>
              {item && item.name && (
                <>
                  <b>Name:</b> {item.name} <br />
                </>
              )}
              {item && item.email && (
                <>
                  <b>Email:</b> {item.email}
                </>
              )}
            </ColumnWidth>
          )
        }
      }
    ]


    return (
      <div>

        <div className='row  mt-4'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='table-head d-flex align-items-center'>
                <h5>Advance Commission List</h5>
                <div className='search-box-table'>

                </div>

                <div className='sort-box-table mark-btn'>
                  <div>

                  </div>
                </div>

              </div>
              <div className='card-body table-responsive'>
                <Row className={'filter_box'} gutter={16}>
                  <Col md={6} sm={6} xs={8} lg={6}>
                    <InputBox title={'Search By Agent'} labelCls={'labelDoc'}>
                      <AgentTypeheadComponent
                        key={this.state.agentId}
                        agentId={this.state.agentId}
                        dispatch={this.props.dispatch}
                        customStyle={''}
                        onSelect={item => {
                          this.setState({
                            agentId: item
                          })
                        }}
                      />
                    </InputBox>
                  </Col>
                  <Col md={6} sm={6} xs={6} lg={6} key={this.state.fromDate}>
                    <InputBox title={'Search by CAS Issue Date'}>
                      <RangePicker
                        defaultValue={[this.state.fromDate, this.state.toDate]}
                        onChange={val => {
                          this.setState({ fromDate: val[0] })
                          this.setState({ toDate: val[1] })
                        }}
                      />
                    </InputBox>
                  </Col>
                  <Col span={24}>
                    <div className={'btn_group'}>
                      <a className={'default_btn'} onClick={this.searchFxn}>Search</a>
                      <a className={'default_btn'} onClick={this.clearFxn}>Clear</a>
                    </div>
                  </Col>
                </Row>
                <TableComp columns={columns}
                           ref={this.tableRef}
                           pagination={DefaultTablePagination()}
                           apiRequest={this.apiRequest}
                           extraProps={{ scroll: { x: 2000 } }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvanceCommissionList)
